import { calcBackgroundVideoSize } from '../modules/background-videos-size';
import { getRandomBackground } from '../modules/random-background';

export const loadYoutubeVideos = () => {
  $('.js-video-simple').each(function () {
    const $video = $(this);
    const videoUrl = $video.data('video');
    const autoplay = $video.attr('data-autoplay');

    if (videoUrl.includes('youtube.com')) {
      let videoId = videoUrl.split('?v=').pop().split('&')[0];

      let player = new YT.Player(this, {
        videoId: videoId,
        events: {
          onReady: onPlayerReady,
        },
      });

      function onPlayerReady(event) {
        // Has autoplay attribute
        if (typeof autoplay !== typeof undefined && autoplay !== false) {
          player.playVideo();
        }
      }
    }
  });

  $('.js-video-background').each(function () {
    const $video = $(this);
    let videoUrl = $video.data('video');
    if (videoUrl.includes('@')) {
      const randomVideo = getRandomBackground(videoUrl);
      videoUrl = randomVideo;
    }

    const videoId = videoUrl.split('?v=').pop();

    if (videoUrl.includes('youtube.com')) {
      let videoId = videoUrl.split('?v=').pop().split('&')[0];

      let player = new YT.Player(this, {
        videoId: videoId,
        playerVars: {
          autoplay: 1, // Auto-play the video on load
          playsinline: 1,
          loop: 1, // Run the video in a loop
          controls: 0, // Show pause/play buttons in player
          disablekb: 1,
          showinfo: 0, // Hide the video title
          modestbranding: 1, // Hide the Youtube Logo
          rel: 0, // Hide related videos
          fs: 0, // Hide the full screen button
          cc_load_policy: 0, // Hide closed captions
          iv_load_policy: 3, // Hide the Video Annotations
          autohide: 0, // Hide video controls when playing
        },
        events: {
          onReady: function (event) {
            event.target.mute();
            event.target.playVideo();

            calcBackgroundVideoSize();

            $(window).on('resize orientationchange', function () {
              calcBackgroundVideoSize();
            });
          },
          onStateChange: function (event) {
            // video ended
            if (event.data == 0) {
              event.target.playVideo();
            }
          },
        },
      });
    }
  });

  $('.js-video-control').each(function () {
    const $video = $(this);
    const $container = $video.closest('.js-video');
    const $btn = $container.find('.js-btn-play');
    const videoUrl = $video.data('video');

    if (videoUrl.includes('youtube.com')) {
      const videoId = videoUrl.split('?v=').pop();

      let player = new YT.Player(this, {
        videoId: videoId,
        events: {
          onStateChange: function (event) {
            if (event.data == 0) {
              $container.removeClass('is-playing');
            }
          },
        },
      });

      $btn.on('click touchstart', function (event) {
        event.preventDefault();
        $container.addClass('is-playing');
        player.playVideo();
      });
    }
  });
};
